export const routePaths = {
    // Auth
    AUTH_VIEW_PATH: '/auth',
    LOGIN_VIEW_PATH: '',
    FORGOT_PASSWORD_VIEW_PATH: 'forgot-password',
    FORGOT_PASSWORD_SET_NEW_PASSWORD_VIEW_PATH: 'forgot-password/:token',
    //Views
    ROOT_PATH_WITH_SUB_ACCOUNT_ID: '/subaccount/:subAccountId',
    SUB_ACCOUNT_PROFILE_VIEW_PATH: 'profile',
    REPORTS_VIEW_PATH: 'reports',
    MESSAGES_VIEW_PATH: 'messages',
    REPORT_EDIT_VIEW_PATH: 'report/edit/:reportId',
    MESSAGES_LIST_VIEW_PATH: ':messageCategory',
    MESSAGE_DETAILS_VIEW_PATH: ':messageCategory/:messageId',
    MESSAGE_EDIT_VIEW_PATH: ':messageCategory/:messageId/edit',
    // Terms and CHILD_PROTECTION
    GUARDIAN_TERMS_VIEW_PATH: '/terms/:subAccountId?',
    CHILD_PROTECTION_VIEW_PATH: '/child-protection',
    // Not found
    PAGE_NOT_FOUND_VIEW_PATH: '/:pathMatch(.*)*',
    // Invitation
    INVITATION_VIEW_PATH: '/invitation/:invitationToken',
}
